import { render, staticRenderFns } from "./NshopOrderList.vue?vue&type=template&id=19c9c462&scoped=true&"
import script from "./NshopOrderList.vue?vue&type=script&lang=js&"
export * from "./NshopOrderList.vue?vue&type=script&lang=js&"
import style0 from "./NshopOrderList.vue?vue&type=style&index=0&id=19c9c462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c9c462",
  null
  
)

export default component.exports